import LegalLayout, { LegalSection } from "@/components/site/LegalLayout";
import { BRAND } from "@/lib/brand";
import SEO from "@/components/SEO";

export default function Cookies() {
  return (
    <LegalLayout title="Cookies Policy" updatedAt="June 2026" testid="cookies-page">
      <SEO title="Cookies Policy" description="How Greinch WW LLC uses cookies and similar tracking technologies." path="/cookies" />
      <p>
        This Cookies Policy explains how {BRAND.name} uses cookies and similar technologies on
        our website. It should be read together with our{" "}
        <a href="/privacy" className="text-coral hover:underline">Privacy Policy</a>.
      </p>

      <LegalSection heading="1. What are cookies?">
        <p>
          Cookies are small text files placed on your device when you visit a website. They allow
          the website to recognise your device and remember information about your visit (such as
          your preferences) and to support basic functionality, analytics and marketing.
        </p>
      </LegalSection>

      <LegalSection heading="2. Categories of cookies we may use">
        <ul className="list-disc list-outside pl-5 space-y-2">
          <li>
            <strong className="text-[#F4EADE]">Strictly necessary cookies.</strong> Required for
            the website to function, including navigation and security. These cannot be disabled.
          </li>
          <li>
            <strong className="text-[#F4EADE]">Performance / analytics cookies.</strong> Help us
            understand how visitors use our site, so we can improve it.
          </li>
          <li>
            <strong className="text-[#F4EADE]">Functional cookies.</strong> Remember choices you
            make (such as language) to provide a more personal experience.
          </li>
          <li>
            <strong className="text-[#F4EADE]">Marketing cookies.</strong> May be set by us or
            partners to deliver relevant communications. Only used with your consent.
          </li>
        </ul>
      </LegalSection>

      <LegalSection heading="3. Managing cookies">
        <p>
          You can control or delete cookies through your browser settings at any time. Disabling
          some cookies may affect your experience on this website.
        </p>
        <p>
          Most browsers also let you set preferences to block third-party cookies or to clear
          cookies on exit.
        </p>
      </LegalSection>

      <LegalSection heading="4. Third-party cookies">
        <p>
          We may use selected third-party services (such as analytics or content delivery
          providers) that set their own cookies. These third parties have their own privacy and
          cookie policies which we recommend you review.
        </p>
      </LegalSection>

      <LegalSection heading="5. Changes">
        <p>
          We may update this Cookies Policy from time to time. The latest version is always
          available on this page with an updated date.
        </p>
      </LegalSection>

      <LegalSection heading="6. Contact">
        <p>
          Questions about cookies? Contact us at{" "}
          <a href={`mailto:${BRAND.email}`} className="text-coral hover:underline">
            {BRAND.email}
          </a>.
        </p>
        <p>
          {BRAND.name}<br />
          {BRAND.address}<br />
          {BRAND.addressLine2}
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
